import {CookieService} from "ngx-cookie-service";

export default class TokenUtils
{
    static getToken(cookieService: CookieService, tokenCookieName: string): any {
      const cookieValue = cookieService.get(tokenCookieName);

      if (!cookieValue) {
        return undefined;
      }

      try {
        // Try to decode — if it works and looks like a JWT, return it
        const decoded = window.atob(cookieValue);
        // Simple check: decoded value contains two dots like a JWT should
        if (decoded.split('.').length === 3) {
          return decoded;
        }
      } catch (e) {
        // Not Base64 or not decodable
      }

      // Either not Base64, or not a valid decoded JWT, return raw
      return cookieValue;
    }

    static clearToken(cookieService: CookieService, tokenCookieName: string): any
    {
       cookieService.delete(tokenCookieName);
    }

}
